<page-data-manager>
  <div class="flash-message-container">
    <flash-message></flash-message>
  </div>
  <div class="row">
    <div class="col-xs-12">
      <div class="row">
        <div class="col-xs-12">
          <div class="panel panel-default no-margin">
            <div class="panel-heading">
              <h4 class="panel-title">Dados de colheita</h4>
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-xs-12">
                  <p><b>Cultura:</b> {{cadastroColheita.colheita.atividade.descricao | capitalize}}</p>
                  <p><b>Cultivar:</b> {{cadastroColheita.colheita.insumo.descricao}}</p>
                  <p><b>Talhão:</b> {{cadastroColheita.colheita.gleba.gleba.descricao | capitalize}}</p>
                  <p><b>Período:</b> {{cadastroColheita.colheita.data_inicio | date:'dd/MM'}} à {{cadastroColheita.colheita.data_termino | date:'dd/MM'}}</p>
                  <p><b>Área total:</b> {{cadastroColheita.colheita.area_total_ha | number:2}} ha</p>
                  <span ng-if="!cadastroColheita.isCana()">
                    <p><b>Total colhido:</b> {{cadastroColheita.colheita.total_colhido_kg | number:2}} kg</p>
                  </span>
                  <span ng-if="cadastroColheita.isCana()">
                    <p><b>Total colhido:</b> {{cadastroColheita.colheita.total_colhido_ton | number:2}} ton</p>
                    <p><b>ATR médio:</b> {{cadastroColheita.colheita.atr_medio | number:2}}</p>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row pull-right padding-top-10" ng-include="'views/colheitas/_show_buttons.html'"></div>
    </div>
  </div>
</page-data-manager>
